<template>
  <v-container>
    <v-row class="text-center">
      <v-col cols="12">
        <v-img
          :src="require('../assets/FlagFlat4Small.jpg')"
          padding
          contain
          height="200"
          class="mt-2"
          />
      </v-col>

      <v-col class="mb-1">
        <h3 class="display-1  mb-1">Welcome to EverSoftKnits</h3>
        <p class="subheading font-weight-regular">
          Please visit and support our local vendors
          <br>during the following show dates
        </p>
      </v-col>
      
      <v-col class="mb-1" cols="12">
        <v-row justify="center">
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-center" >
                  <!-- {{ new Date().getFullYear() }} -->
                    2026
                  </th>
                  <th class="text-center">
                    Venue
                  </th>
                  <th class="text-center">
                  Location
                  </th>
                  <th class="text-center">
                    Directions
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="show in shows" :key="show.name">
                  <td>{{ show.date }}</td>
                  <td>{{ show.venue }}</td>
                  <td>{{ show.location }}</td>
                  <td><v-btn text router :to="show.route"><v-icon>mdi-map</v-icon></v-btn></td>
                </tr>
              </tbody>
            </template>
      </v-simple-table>
      <br>
<template>
  <v-container
    class="fill-height"
    fluid
    style="min-height: 300px"
  >
      <v-row>
        <v-col cols="4">
            <v-img
              :src="require('../assets/Foothills2026.jpeg')"
              height="200"
              contain
            ></v-img>
        </v-col>
        <v-col cols="4">
            <v-img
              :src="require('../assets/HomeWorkshop.jpeg')"
              height="200"
              contain
            ></v-img>
        </v-col>
       <v-col cols="4">
            <v-img
              :src="require('../assets/TimnathDisplay.jpeg')"
              height="200"
              contain
            ></v-img>
        </v-col>
      </v-row>
  </v-container>
</template>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    data () {
      return {
        shows: [
          {
            date: 'October 17-18',
            venue: 'Mollie McGees',
            location: 'Boulder County Fairgrounds',
            route: '/boulder'
          },
          {
            date: 'Oct 24',
            venue: 'St.Johns Holiday Fair',
            location: 'St. John Parish - Loveland',
            route: '/stjohn'
          },
          {
            date: 'Oct 31',
            venue: 'Autumn Artisan Market',
            location: 'Chaparral High School - Parker',
            route: '/chaparral'
          },
          {
            date: 'November 7',
            venue: 'Fall Festival and Bake Sale',
            location: 'Presbyterian Church - Ft Collins',
            route: '/presbyterian'
          },
          {
            date: 'November 14-15',
            venue: 'Country Christmas',
            location: 'Adams County Fairgrounds -Brighton',
            route: '/riverdale'
          },
          {
            date: 'November 21-22',
            venue: 'Christmas in Windsor',
            location: 'Rec Center - Windsor ',
            route: '/windsor'
          },
          {
            date: 'November 28',
            venue: 'Foothills Winter Market',
            location: 'Foothills Mall - Ft Collins',
            route: '/foothills'
          },
          {
            date: 'December 5-6',
            venue: 'Holiday Craft Fair',
            location: 'Lyons Elementary School',
            route: '/lyons'
          },
          {
            date: 'December 12',
            venue: 'Foothills Winter Market',
            location: 'Foothills Mall - Ft Collins',
            route: '/foothills'
          },
          {
            date: 'December 19',
            venue: 'Foothills Winter Market',
            location: 'Foothills Mall - Ft Collins',
            route: '/foothills'
          },
          {
            date: 'December 20',
            venue: 'Holiday Makers Market',
            location: 'Breckenridge Brewery - Ft Collins',
            route: '/breckenridge'
          },
        ],
      }
    },
  }
</script>

